import { Dialog, DialogTitle, DialogContent, DialogActions, Grid, InputLabel, Select, MenuItem, TextField } from "@mui/material";
import MDButton from "components/MDButton";
import { useState } from "react";
import { post } from "utils/WebService";

export default function LoteAssociacaoModal({ open, handleClose, marcacaoId, marcacaoObj }) {
    const [tipoAssoc, setTipoAssoc] = useState(marcacaoObj?.cvAlvo === 2 ? "contratos" : "devedores");
    const [idsList, setIdsList] = useState("");
    const [loading, setLoading] = useState(false);

    const handleApply = () => {
        if (!idsList.trim()) {
            alert("Informe os IDs");
            return;
        }
        
        const ids = idsList.split(/[\s,;]+/).map(i => parseInt(i.trim())).filter(i => !isNaN(i));
        
        if (ids.length === 0) {
            alert("Nenhum ID válido encontrado");
            return;
        }

        setLoading(true);
        const endpoint = tipoAssoc === "devedores" ? "/marcacoes/lote/devedores" : "/marcacoes/lote/contratos";
        
        const payload = {
            idMarcacao: marcacaoId,
        };
        
        if (tipoAssoc === "devedores") {
            payload.devedoresIds = ids;
        } else {
            payload.contratosIds = ids;
        }

        post(endpoint, payload).then(() => {
            setLoading(false);
            alert("Associação em lote realizada com sucesso!");
            handleClose();
        }).catch(() => {
            setLoading(false);
            alert("Erro ao realizar associação em lote");
        });
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Associação em Lote - {marcacaoObj?.ccNome}</DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <InputLabel>Associar a</InputLabel>
                        <Select
                            fullWidth
                            value={tipoAssoc}
                            onChange={(e) => setTipoAssoc(e.target.value)}
                            sx={{ height: 44 }}
                        >
                            {(marcacaoObj?.cvAlvo === 1 || marcacaoObj?.cvAlvo === 3) && <MenuItem value="devedores">Fichas (Devedores)</MenuItem>}
                            {(marcacaoObj?.cvAlvo === 2 || marcacaoObj?.cvAlvo === 3) && <MenuItem value="contratos">Contratos</MenuItem>}
                        </Select>
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel>IDs (separados por vírgula ou espaço)</InputLabel>
                        <TextField
                            multiline
                            rows={5}
                            fullWidth
                            variant="outlined"
                            placeholder="Ex: 102, 105, 203"
                            value={idsList}
                            onChange={(e) => setIdsList(e.target.value)}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <MDButton color="secondary" onClick={handleClose}>Cancelar</MDButton>
                <MDButton color="info" onClick={handleApply} disabled={loading}>Aplicar Lote</MDButton>
            </DialogActions>
        </Dialog>
    );
}
